import { Injectable }          from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
// import { AngularFireDatabase } from 'angularfire2/database';
// import { AngularFireAuth }     from 'angularfire2/auth';
// import * as firebase from 'firebase';
// import * as firebase from 'firebase/app';

import 'rxjs/add/operator/take';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/observable/fromPromise';
import { catchError, map, tap } from 'rxjs/operators';

import { URLSearchParams } from '@angular/http';
import { environment } from 'environments/environment';
import { User, Team, Notification, NotificationType, NGXLogger } from '@app/shared';

@Injectable()
export class MessagingService {
    private messaging: any; // Use 'any' because Firebase is loaded globally
    currentMessage = new BehaviorSubject<any>(null);
    messages: Notification[] = [];
  // messaging = firebase.messaging();

  constructor(private http: HttpClient, private logger:NGXLogger) {

    this.initializeFirebase();
    // this.messaging.usePublicVapidKey('BFIktn4TRUGQn673JuohNxpQSnAaN4Lemx4ihLsW8H4OzD8u1_W3mVCP0EXVYjxU02N819Ge88ytFjOcV6M2OqM');
      
    // // Ensure that the Firebase SDK is loaded
    //   if (window['firebase']) {
    //     const app = window['firebase'].initializeApp(environment.firebase);
    //     this.messaging = window['firebase'].messaging(app);
    //     this.messaging.usePublicVapidKey('BFIktn4TRUGQn673JuohNxpQSnAaN4Lemx4ihLsW8H4OzD8u1_W3mVCP0EXVYjxU02N819Ge88ytFjOcV6M2OqM');
    //   } else {
    //     this.logger.error('Firebase SDK is not loaded.');
    //   }

    //   console.log('Firebase:', window['firebase']);
  }

  private initializeFirebase() {
    if (typeof window['firebase'] !== 'undefined') {
      // Ensure Firebase App and Messaging are loaded
      if (typeof window['firebase'].initializeApp === 'function' && typeof window['firebase'].messaging === 'function') {
        const firebaseConfig = environment.firebase; // Ensure this is correctly defined
        const app = window['firebase'].initializeApp(firebaseConfig);

        this.messaging = window['firebase'].messaging(app);
        if (this.messaging) {
          this.messaging.usePublicVapidKey('BFIktn4TRUGQn673JuohNxpQSnAaN4Lemx4ihLsW8H4OzD8u1_W3mVCP0EXVYjxU02N819Ge88ytFjOcV6M2OqM');
          this.logger.info('Firebase Messaging initialized.');
        } else {
          this.logger.error('Firebase Messaging is not initialized.');
        }
      } else {
        this.logger.error('Firebase App or Messaging is not available in window.firebase.');
      }
    } else {
      this.logger.error('Firebase SDK is not loaded.');
    }
  }

  // updateToken(token) {
  //   this.afAuth.authState.take(1).subscribe(user => {
  //     if (!user) return;
  //
  //     //const data = { [user.uid]: token }
  //     //this.db.object('fcmTokens/').update(data)
  //   })
  // }

  // init(navigator:any){
  //   const _self = this;
  //   this.logger.debug(navigator,'init');
  //   navigator.serviceWorker.addEventListener('message', function(event) {
  //     const data = event.data['firebase-messaging-msg-data']?event.data['firebase-messaging-msg-data'].data:event.data.data;
  //     _self.logger.info(data);
  //     if(event.data && data.subject){
  //       let notification = Object.assign( new Notification(), data );
  //       _self.messages.push(notification);

  //       if(data.type === NotificationType.TYPE_SERVICE){
  //         _self.currentMessage.next(data);
  //       }
  //     }else{
  //       _self.currentMessage.next(data);
  //     }

  //     // else
  //     //   this.currentMessage.next(event.data);

  //     _self.logger.debug('Received a message from service worker: ', event.data);
  //   });
  // }

  init(navigator: any) {
    if (this.messaging) {
      navigator.serviceWorker.addEventListener('message', (event: any) => {
        const data = event.data['firebase-messaging-msg-data'] ? event.data['firebase-messaging-msg-data'].data : event.data.data;
        this.logger.info(data);
        if (event.data && data.subject) {
          const notification = Object.assign(new Notification(), data);
          this.messages.push(notification);

          if (data.type === NotificationType.TYPE_SERVICE) {
            this.currentMessage.next(data);
          }
        } else {
          this.currentMessage.next(data);
        }

        this.logger.debug('Received a message from service worker: ', event.data);
      });
    }
  }
  // getPermission(user:User) {

  //   //return Observable.create(observer => {
  //     this.messaging.requestPermission()
  //     .then(() => {
  //       this.logger.info('Notification permission granted.');

  //       return this.messaging.getToken()
  //       //return this.messaging.getToken()
  //     })
  //     .then(token => {
  //       this.logger.debug(token);
  //       this.updateToken(user,token).subscribe(result => {
  //         this.logger.info(result, 'update token')
  //       });
  //       // setTimeout(_ => {
  //       //   this.sendMessage(token).subscribe(result =>{
  //       //     this.logger.debug(result, ' message here')
  //       //   });
  //       // },10000)

  //     })
  //     .catch((err) => {
  //       this.logger.debug('Unable to get permission to notify.', err);
  //     });


  //     // Callback fired if Instance ID token is updated.
  //     this.messaging.onTokenRefresh(function() {
  //       this.messaging.getToken().then(function(refreshedToken) {
  //         this.logger.info('Token refreshed.');
  //         // Indicate that the new Instance ID token has not yet been sent to the
  //         // app server.
  //         this.updateToken(user,refreshedToken).subscribe(result => {
  //           this.logger.info(result, 'update token')
  //         });
  //         // ...
  //       }).catch(function(err) {
  //         this.logger.error('Unable to retrieve refreshed token ', err);

  //       });
  //     });


  //     //return observer.next({messaging:this.messaging,currentMessage:this.currentMessage});

  //   //})

  //   }// end function

  getPermission(user: User): void {

    console.log(this.messaging)
    if (this.messaging) {
      this.messaging.requestPermission()
        .then(() => {
          this.logger.info('Notification permission granted.');
          return this.messaging.getToken();
        })
        .then((token: string) => {
          this.logger.debug(token);
          this.updateToken(user, token).subscribe(result => {
            this.logger.info(result, 'update token');
          });
        })
        .catch((err) => {
          this.logger.debug('Unable to get permission to notify.', err);
        });

      this.messaging.onTokenRefresh(() => {
        this.messaging.getToken().then((refreshedToken: string) => {
          this.logger.info('Token refreshed.');
          this.updateToken(user, refreshedToken).subscribe(result => {
            this.logger.info(result, 'update token');
          });
        }).catch((err) => {
          this.logger.error('Unable to retrieve refreshed token ', err);
        });
      });
    }
  }

  receiveMessage() {
    if (this.messaging) {
      this.messaging.onMessage((payload: any) => {
        this.logger.info('Message received. ', payload);
        this.currentMessage.next(payload);
      });
    }
  }

    sendMessage(token:string): Observable<any>{
      const url = `${environment.baseURL}firebase/sendmessage`;

      let httpParams = new HttpParams();
      let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
      let urlSearchParams = new URLSearchParams();

      urlSearchParams.append('tk',token);
      let bodyParams = urlSearchParams.toString();

      return this.http.post(url,bodyParams,{
         //params : httpParams
         headers: headers
      })

    }

    sendTeamNotification(contacts:User[] , subject:string, message:string, teams:Team[], type:string, all:boolean, data:any): Observable<any>{
      const url = `${environment.baseURL}firebase/sn`;

      let httpParams = new HttpParams();
      let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
      let urlSearchParams = new URLSearchParams();

      var tmpTeams = [];
      var tmpUsers = [];

      teams.map(team => tmpTeams.push(team.name));
      contacts.map(user => tmpUsers.push(user.uuid));

      urlSearchParams.append('contacts',tmpUsers.join(','));
      urlSearchParams.append('subject',subject);
      urlSearchParams.append('message',message);
      urlSearchParams.append('team',tmpTeams.join(','));
      urlSearchParams.append('type',type);
      urlSearchParams.append('data',JSON.stringify(data));
      //urlSearchParams.append('all',`${all}`);

      let bodyParams = urlSearchParams.toString();

      return this.http.post(url,bodyParams,{
         //params : httpParams
         headers: headers
      })
    }

    clearMessages():void{
      this.messages.length = 0;
    }
    deleteToken(token:string):Promise<any>{
      return this.messaging.deleteToken(token)
    }
    updateToken(user:User,token:string): Observable<any>{
      const url = `${environment.baseURL}cache/update/tk`;

      let httpParams = new HttpParams();
      let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
      let urlSearchParams = new URLSearchParams();
      let userAgent = this.getUserAgentInfo();

      urlSearchParams.append('userAgent',`${userAgent}`);
      urlSearchParams.append('val',`${token}`);
      this.logger.info(userAgent, ' User Agent')
      //urlSearchParams.append('all',`${all}`);

      let bodyParams = urlSearchParams.toString();

      if(localStorage.getItem('user')){
        user.fbToken = token;
        user.userAgent = userAgent;

        this.logger.debug('updateing token and user')
        localStorage.setItem('user', JSON.stringify(user));
      }


      return this.http.post(url,bodyParams,{
         //params : httpParams
         headers: headers
      })
    }

    private getUserAgentInfo():any{
      var ua= navigator.userAgent, tem,
      M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if(/trident/i.test(M[1])){
          tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
          return 'IE '+(tem[1] || '');
      }
      if(M[1]=== 'Chrome'){
          tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
          if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
      M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
      if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
      return M.join(' ');
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/messaging.service.ts